import { render } from "./StockSummaryReport.vue?vue&type=template&id=676c0526&scoped=true"
import script from "./StockSummaryReport.vue?vue&type=script&lang=js"
export * from "./StockSummaryReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=676c0526&scoped=true&lang=css&external"
import "./StockSummaryReport.vue?vue&type=style&index=1&id=676c0526&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676c0526"]])

export default __exports__